<template>
  <div class="bbl-toolbar-group">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'ToolbarGroup'
}
</script>
